import CardDsl from '../CardDsl'
import { CourseInfo } from './CourseInfo'
import CardPrice from '../CardPrice'

import Proptypes from 'prop-types'

const AdventureCourseCard = ({
  adventure,
  isHighlighted,
  isCourse,
  activityPage,
  isWidget,
  externalPage,
  isBlocked,
}) => {
  return (
    <CardDsl adventure={adventure} isHighlighted={isHighlighted} activityPage={activityPage}>
      <CourseInfo adventure={adventure} infoType='adventure' />
      <CardPrice
        adventure={adventure}
        type='adventure'
        isCourse={isCourse}
        activityPage={activityPage}
        isWidget={isWidget}
        isBlocked={isBlocked}
        externalPage={externalPage}
      />
    </CardDsl>
  )
}

export default AdventureCourseCard

AdventureCourseCard.propTypes = {
  adventure: Proptypes.object,
  isHighlighted: Proptypes.bool,
  isCourse: Proptypes.bool,
  activityPage: Proptypes.string,
  isWidget: Proptypes.bool,
  externalPage: Proptypes.string,
  isBlocked: Proptypes.bool,
}
